<template>
    <ReactPage>
        <game-configuration-page></game-configuration-page>
    </ReactPage>
  </template>
  
  <script>
  import ReactPage from '../components/ReactPage.vue';
  
  export default {
    name: "GameConfiguration",
    components: {
      ReactPage
    }
  }
  </script>